import customizationFields from '../../../fields/customizationFields';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import DropdownCustomizationActionsRow from '../../dropdown/DropdownCustomizationActionsRow';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import RouteUrls from '@/app/root/enums/RouteUrls';
import Permissions from '@/app/permissions/Permissions';
import { Badge } from '@/common-utils/components/ui/badge';
import CUSTOMIZATION_STATUS from '../../../enums/CustomizationStatus';
import CUSTOMIZATION_URL_ACTIONS from '../../../enums/CustomizationUrlActions';
import MERCHANT_ACCOUNT_DETAILS_TABS from '@/app/root/enums/tabs/MerchantAccountDetailsTabs';
import CopyableChip from '@/common-utils/components/renders/copyableChip/CopyableChip';

export const columnsCustomizationId = 'customizations';

export const columnsCustomization = (headerPackage) => {

    return ([
        // DETAILS
        generateColumnDefByField({
            field: customizationFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{
                        contractAccessId: headerPackage.merchantAccountId,
                        customizationId: row.original.uuid
                    }}
                    baseUrl={RouteUrls.PAYLUDD_CUSTOMIZATION_MANAGEMENT.url}
                    urlParams={{
                        view: MERCHANT_ACCOUNT_DETAILS_TABS.CUSTOMIZATION.name,
                        action: row.original.packageCode ? CUSTOMIZATION_URL_ACTIONS.SHOW : CUSTOMIZATION_URL_ACTIONS.EDIT
                    }}
                    requiredPermissions={[Permissions.CONTRACTS_ACCESS_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        // UUID - Actions dropdown
        generateColumnDefByField({
            field: customizationFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row &&
                <DropdownCustomizationActionsRow
                    customization={row.original}
                    setLaunchRefetch={headerPackage.setLaunchRefetch}
                    merchantAccountId={headerPackage.merchantAccountId}
                />
            )
        }),
        // LABEL - Nom de la personnalisation
        generateColumnDefByField({
            field: customizationFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        // CODE - Code de package avec format XXX - XXX - XXX
        generateColumnDefByField({
            field: customizationFields.IDENTIFIANT,
            headerPackage: headerPackage,
            customCellFn: ({ cell, row }) => {
                const value = cell.getValue();
                if (!value) {
                    return null;
                }
                const formattedValue = `${value}`.replace(/(\d{3})(\d{3})(\d{3})/, '$1 - $2 - $3');

                return (
                    <CopyableChip
                        key={row?.original?.uuid ?? value}
                        text={formattedValue}
                        copyText={value}
                    />
                );
            }
        }),
        // STATUS - Statut (PUBLISHED/DRAFT basé sur packageCode)
        generateColumnDefByField({
            field: customizationFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row.original.packageCode ?
                    <Badge
                        entity={CUSTOMIZATION_STATUS.PUBLISHED.entity}
                        namespace={CUSTOMIZATION_STATUS.PUBLISHED.namespace}
                        variant={CUSTOMIZATION_STATUS.PUBLISHED.variant}
                    /> :
                    <Badge
                        entity={CUSTOMIZATION_STATUS.DRAFT.entity}
                        namespace={CUSTOMIZATION_STATUS.DRAFT.namespace}
                        variant={CUSTOMIZATION_STATUS.DRAFT.variant}
                    />
            )
        }),
        // NUMBERS_OF_POS_TERMINALS - Nombre de terminaux POS
        generateColumnDefByField({
            field: customizationFields.POS_TERMINALS_NUMBERS,
            headerPackage: headerPackage
        }),
        // UPDATED_AT - Date de mise à jour
        generateColumnDefByField({
            field: customizationFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell.getValue() && <RenderDateWithFromTime value={cell.getValue()} />
            )
        }),
        // COLOR_CODE - Code couleur (en enlevant le #)
        generateColumnDefByField({
            field: customizationFields.COLOR,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell.getValue() ? cell.getValue().slice(1) : null
            )
        }),
        // LOGO - Logo avec background coloré
        generateColumnDefByField({
            field: customizationFields.LOGO,
            headerPackage: headerPackage,
            customCellFn: ({ cell, row }) => {
                const logoUrl = cell.getValue();
                const color = row.original.color;
                return (
                    <div className='flex items-center justify-center h-full w-full'>
                        {color &&
                            <div className='rounded h-10 w-16 flex items-center justify-center'
                                style={{ backgroundColor: color }}>
                                {logoUrl &&
                                    <img alt='Logo'
                                        className='max-w-[50px] max-h-[30px] object-contain'
                                        src={logoUrl}
                                    />
                                }
                            </div>
                        }
                    </div>
                );
            }
        }),
        // LOCALE - Locale (en enlevant les 3 premiers caractères)
        generateColumnDefByField({
            field: customizationFields.LOCALE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell.getValue() ? cell.getValue().slice(3) : null
            )
        }),
        // CREATED_AT - Date de création
        generateColumnDefByField({
            field: customizationFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell.getValue() && <RenderDateWithFromTime value={cell.getValue()} />
            )
        })
    ]);
};